export { default } from './ChatBubbleDotsOutline'
